import HelperClassesContainer from "../../Componant/Ui Kit/HelperClasses";

const HelperClasses = () => {
  return (
    <div className="page-body">
      <HelperClassesContainer />
    </div>
  );
};

export default HelperClasses;
